export default __webpack_public_path__ + "static/media/tuto_kingdom_2_2x.bda27be4.webp";